import { render, staticRenderFns } from "./MunicipalityModal.vue?vue&type=template&id=6c816dc2&"
import script from "./MunicipalityModal.vue?vue&type=script&lang=js&"
export * from "./MunicipalityModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports